import { useTranslation } from 'next-i18next';
import React from 'react';

const Statistics = () => {
  const { t, i18n } = useTranslation(['whyWukong']);
  const isZh = i18n.language === 'zh';

  const list = [
    { title: t('国家和地区'), value: isZh ? '118个' : '118' },
    { title: t('优秀教师'), value: isZh ? '4500位' : '4500' },
    { title: t('师资严选率'), value: '1%' },
    { title: t('累计授课小时数'), value: isZh ? '1100万' : '11 Million+' },
  ];

  return (
    <div className="container mt-[13px] flex flex-wrap justify-between lg:mt-[50px] xl:mt-[80px]">
      {list.map(({ title, value }) => (
        <div
          key={title}
          className="mt-[15px] flex h-[139px] w-[160px] flex-col items-center justify-center rounded-[24px] border-[2px] border-solid border-[rgba(255,255,255,0.45)] bg-[linear-gradient(0deg,rgba(255,255,255,0.40)_0%,rgba(255,255,255,0.90)_100%)]  px-[8px] shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)] lg:mt-0 lg:h-[144px] lg:w-[228px] lg:px-[12px] xl:mt-0 xl:h-[165px] xl:w-[330px] xl:px-[12px]"
        >
          {isZh ? (
            <h3 className="font-sourceHanSans text-[28px] font-black text-[#1B1F4D] xl:text-[34px]">{value}</h3>
          ) : (
            <h3 className="text-[28px] font-black text-[#1B1F4D] xl:text-[34px]">{value}</h3>
          )}
          <p className="mt-[8px] text-center text-[14px] text-[#484C70] lg:text-[16px] xl:text-[20px]">{title}</p>
        </div>
      ))}
    </div>
  );
};

export default Statistics;
